module.exports = new __parcel__URL__("neon_gold_accelerator_level_2.e3251fde.png").toString();